// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1__f65578f8b9958bb8891f{/*!*/}.ResearchInterestTags-cls2___fa4262b584621fde780{}.ResearchInterestTags-cls2___fa4262b584621fde780.ResearchInterestTags-hasError___5d36032d8edd5630f0f{border-color:#e62419}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1__f65578f8b9958bb8891f",
	"cls2": "ResearchInterestTags-cls2___fa4262b584621fde780 ResearchInterestTags-cls1__f65578f8b9958bb8891f",
	"hasError": "ResearchInterestTags-hasError___5d36032d8edd5630f0f"
};
export default ___CSS_LOADER_EXPORT___;
